// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemBox[data-v-130fb642] {\n  display: flex;\n  justify-content: center;\n  font-size: 20px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  color: #000;\n}\n[data-v-130fb642] .ant-form-item-control-wrapper {\n  flex: 1;\n  overflow: hidden;\n}\n.richBox[data-v-130fb642] {\n  border: 1px solid #f5f5f5;\n  border-radius: 5px;\n  padding: 0 10px;\n  min-height: 400px;\n}", ""]);
// Exports
module.exports = exports;
